/* eslint-disable react/prop-types */
/** @jsxRuntime classic */
/** @jsx jsx */
import { memo, useState, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import { brand, dark11, dark6, blue13 } from "../../../styles/colors";
import { typography } from "../../../styles/typography";
const icons = {
  expand: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clip-rule="evenodd" d="M11.9999 12.0001C11.7729 12.0001 11.5449 11.9231 11.3599 11.7681L5.35989 6.76807C4.93589 6.41407 4.87889 5.78407 5.23189 5.36007C5.58589 4.93507 6.21489 4.87907 6.63989 5.23207L12.0109 9.70707L17.3729 5.39307C17.8029 5.04707 18.4339 5.11507 18.7789 5.54507C19.1259 5.97507 19.0569 6.60407 18.6269 6.95107L12.6269 11.7791C12.4439 11.9261 12.2219 12.0001 11.9999 12.0001ZM12.011 16.7076L17.373 12.3926C17.803 12.0476 18.434 12.1156 18.779 12.5446C19.125 12.9756 19.057 13.6046 18.627 13.9516L12.627 18.7796C12.444 18.9266 12.222 18.9996 12 18.9996C11.772 18.9996 11.545 18.9226 11.36 18.7676L5.35999 13.7676C4.93499 13.4146 4.87799 12.7846 5.23199 12.3596C5.58499 11.9356 6.21499 11.8776 6.63999 12.2316L12.011 16.7076Z" fill="currentColor"/>
    </svg>`,
  collapse: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clip-rule="evenodd" d="M7.00011 6.99993C7.22711 6.99993 7.45511 7.07693 7.64011 7.23193L13.6401 12.2319C14.0641 12.5859 14.1211 13.2159 13.7681 13.6399C13.4141 14.0649 12.7851 14.1209 12.3601 13.7679L6.98911 9.29293L1.62711 13.6069C1.19711 13.9529 0.566109 13.8849 0.221108 13.4549C-0.125891 13.0249 -0.0568903 12.3959 0.373109 12.0489L6.37311 7.22093C6.55611 7.07393 6.77811 6.99993 7.00011 6.99993ZM6.98901 2.29243L1.62701 6.60743C1.19701 6.95243 0.56601 6.88443 0.22101 6.45543C-0.12499 6.02443 -0.0569899 5.39543 0.37301 5.04843L6.37301 0.220434C6.55601 0.0734332 6.77801 0.000434244 7.00001 0.000434264C7.22801 0.000434283 7.45501 0.077434 7.64001 0.232434L13.64 5.23243C14.065 5.58543 14.122 6.21543 13.768 6.64043C13.415 7.06443 12.785 7.12243 12.36 6.76843L6.98901 2.29243Z" fill="currentColor"/>
    </svg>`
};
const Extra = ({
  type,
  displayText,
  style,
  onClick,
  ...props
}) => {
  const extraRef = useRef(null);
  const textRef = useRef(null);
  const iconRef = useRef(null);
  const [typeState, setTypeState] = useState(type);

  /* Start styled */
  const extraIcon = css`
        display: flex;
        align-items: center;
    `;
  const extraText = css`
        margin-left: 9px;
        ${typography.heading4};
        color: ${dark6};
    `;
  const extra = css`
        width: 100%;
        height: 40px;
        background-color: ${dark11};
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${dark6};
        cursor: pointer;
        &:hover {
            background-color: ${blue13};
            .css-${extraIcon.name} {
                color: ${brand};
                path: {
                    fill: ${brand};
                }
            }
            .css-${extraText.name} {
                color: ${brand};
            }
        }
    `;
  /* End styled */

  /* Start handler */
  const handleClick = () => {
    if (typeState === 'expand') {
      iconRef.current.innerHTML = icons.collapse;
      textRef.current.innerHTML = displayText || 'Thu gọn';
      setTypeState('collapse');
    } else {
      iconRef.current.innerHTML = icons.expand;
      textRef.current.innerHTML = displayText || 'Xem thêm';
      setTypeState('expand');
    }
    if (onClick) onClick({
      type: typeState === 'expand' ? 'collapse' : 'expand'
    });
  };
  useEffect(() => {
    iconRef.current.innerHTML = type === 'expand' ? icons.expand : icons.collapse;
    setTypeState(type);
  }, [type]);
  useEffect(() => {
    textRef.current.innerHTML = displayText || (type === 'expand' ? 'Xem thêm' : 'Thu gọn');
  }, [displayText, type]);
  /* End handler */

  /* Start component */
  const iconComp = useMemo(() => jsx("div", {
    ref: iconRef,
    css: extraIcon
  }), []);
  const textComp = useMemo(() => jsx("div", {
    ref: textRef,
    css: extraText
  }, displayText), []);
  /* End component */

  return jsx("div", {
    ...props,
    ref: extraRef,
    css: extra,
    onClick: handleClick,
    style: style
  }, iconComp, textComp);
};
Extra.defaultProps = {
  type: 'expand'
};
Extra.proptypes = {
  type: PropTypes.string,
  displayText: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};
export default /*#__PURE__*/memo(Extra);